var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-container"},[(_vm.$store.state.user.info.username)?_c('span',{staticClass:"account-avatar"},[_c('a-avatar',{attrs:{"src":_vm.userIcon}}),_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.$store.state.user.info.username))])],1):_c('span',{staticClass:"account-avatar"},[_c('a-spin')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }